import { HttpStatusCode } from 'data/protocols/http';
import { InvalidCredentialsError, UnexpectedError } from 'domain/errors';
import { UpdateRecurringPushNotificationUseCaseInterface } from 'domain/usecases';

export class RemoteUpdateRecurringPushNotification
  implements UpdateRecurringPushNotificationUseCaseInterface
{
  constructor(
    private readonly url: string,
    private readonly httpClient,
  ) {}

  async execute(
    params: UpdateRecurringPushNotificationUseCaseInterface.Params,
  ): Promise<UpdateRecurringPushNotificationUseCaseInterface.Result> {
    const { id, ...body } = params;
    const httpResponse = await this.httpClient.request({
      url: this.url + `/${id}`,
      body,
      method: 'put',
    });

    switch (httpResponse.statusCode) {
      case HttpStatusCode.ok:
        return httpResponse.body;
      case HttpStatusCode.unauthorized:
        throw new InvalidCredentialsError();
      default:
        throw new UnexpectedError(httpResponse.body?.message);
    }
  }
}
